import React, { useState } from "react";
import Navbar from "../../../Navbar";
import Sidebar from "../../../Sidebar";
import "./Dashboard.css";
import currencyBRFormat from "../../../util/CurrencyUtils";
import { useEffect } from "react";
import { getDashboardInfo } from "../../../services/DashboardService";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Chart from "../../../components/Chart";
import { CDBSpinner } from "cdbreact";

export const Dashboard = () => {
  const [dashboardInfo, setDashboardInfo] = useState();
  const [toggled, setToggled] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    handleSidebarToggle();
    getDashboardInfo()
      .then((response) => setDashboardInfo(response))
      .catch((error) => console.error("[getDashboardInfo] ", error));
  }, []);

  function handleSidebarToggle() {
    const isMobile = window.innerWidth <= 720;
    if (isMobile) setToggled(true);
  }

  return (
    <div className="d-flex" style={{ height: "100dvh", overflow: "hidden" }}>
      <Sidebar toggled={toggled} />

      <div className="main-content-wrapper bg-light w-100" style={{ overflowY: "auto" }}>
        <Navbar toggled={toggled} setToggled={setToggled} />

        {!dashboardInfo ? (
          <div className="d-flex justify-content-center p-5">
            <CDBSpinner dark />
          </div>
        ) : (
          <main style={{ padding: "20px 5%" }}>
            <div className="mt-3 mb-4">
              <h3 className="fw-bold text-dark">Dashboard</h3>
            </div>

            <div className="row g-3">
              {/* CARD 1: Faturamento Hoje */}
              <div className="col-lg-3 col-md-6">
                <div className="card border-0 shadow-sm h-100 rounded-3 border-start border-primary border-5">
                  <div className="card-body p-4">
                    {/* Alinhamento perfeito pelo topo */}
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <h6 className="text-uppercase fw-bold text-muted small mb-0 pt-2">Faturamento Hoje</h6>
                      {/* Box de ícone premium com fundo sutil */}
                      <div className="bg-primary bg-opacity-10 text-primary rounded-3 d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px', minWidth: '40px' }}>
                        <i className="fa fa-dollar-sign fs-5"></i>
                      </div>
                    </div>
                    <h4 className="fw-bold mb-3">{currencyBRFormat(dashboardInfo.grossRevenue)}</h4>
                    <Link className="text-decoration-none extra-small fw-bold text-primary" to="/relatorios">
                      Ver detalhes <i className="fas fa-arrow-right ms-1"></i>
                    </Link>
                  </div>
                </div>
              </div>

              {/* CARD 2: Serviços Concluídos */}
              <div className="col-lg-3 col-md-6">
                <div className="card border-0 shadow-sm h-100 rounded-3 border-start border-info border-5">
                  <div className="card-body p-4">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <h6 className="text-uppercase fw-bold text-muted small mb-0 pt-2">Serviços concluídos</h6>
                      <div className="bg-info bg-opacity-10 text-info rounded-3 d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px', minWidth: '40px' }}>
                        <i className="fas fa-car fs-5"></i>
                      </div>
                    </div>
                    <h4 className="fw-bold mb-0">{dashboardInfo.totalVehiclesToday || 0}</h4>
                    <p className="text-muted small mt-3 mb-0">Veículos atendidos hoje</p>
                  </div>
                </div>
              </div>

              {/* CARD 3: Em Andamento */}
              <div className="col-lg-3 col-md-6">
                <div className="card border-0 shadow-sm h-100 rounded-3 border-start border-warning border-5">
                  <div className="card-body p-4">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <h6 className="text-uppercase fw-bold text-muted small mb-0 pt-2">Em andamento</h6>
                      <div className="bg-warning bg-opacity-10 text-warning rounded-3 d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px', minWidth: '40px' }}>
                        <i className="fa fa-sync fs-5"></i>
                      </div>
                    </div>
                    <h4 className="fw-bold mb-0">{dashboardInfo.totalPendingServices}</h4>
                    <p className="text-muted small mt-3 mb-0">Veículos no pátio agora</p>
                  </div>
                </div>
              </div>

              {/* CARD 4: A Receber */}
              <div className="col-lg-3 col-md-6">
                <div className="card border-0 shadow-sm h-100 rounded-3 border-start border-danger border-5">
                  <div className="card-body p-4">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <h6 className="text-uppercase fw-bold text-muted small mb-0 pt-2">A Receber</h6>
                      <div className="bg-danger bg-opacity-10 text-danger rounded-3 d-flex align-items-center justify-content-center" style={{ width: '40px', height: '40px', minWidth: '40px' }}>
                        <i className="fa fa-clock fs-5"></i>
                      </div>
                    </div>
                    <h4 className="fw-bold mb-2 text-danger">{currencyBRFormat(dashboardInfo.totalReceivables)}</h4>
                    <Link className="text-decoration-none extra-small fw-bold text-danger" to="/caixa?status=a Prazo">
                      Cobranças <i className="fas fa-arrow-right ms-1"></i>
                    </Link>
                  </div>
                </div>
              </div>

              <div className="col-lg-8 mt-4">
                <div className="card border-0 shadow-sm rounded-3">
                  <div className="card-body p-4">
                    <h5 className="fw-bold mb-4">Faturamento Médio Dias da Semana</h5>
                    <div style={{ height: "300px" }}>
                      <Chart sales={dashboardInfo.salesByDay} />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 mt-4">
                <div className="card border-0 shadow-sm rounded-3">
                  <div className="card-body p-4">
                    <h5 className="fw-bold mb-4">Mais Pedidos ⭐</h5>
                    <div className="list-group list-group-flush">
                      {dashboardInfo.favoriteServices.map((service, idx) => (
                        <div key={idx} className="list-group-item border-0 px-0 d-flex justify-content-between align-items-center">
                          <div>
                            <p className="mb-0 fw-bold">{service[0]}</p>
                            <small className="text-muted">{service[1]} execuções</small>
                          </div>
                          <span className="badge bg-primary bg-opacity-10 text-primary rounded-pill">#{idx + 1}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        )}
      </div>
    </div>
  );
};
